import dc1stScience from "./dc1stScienceQuizContent";
import dc1stSocialStudies from "./dc1stSocialStudiesQuizContent";
import dc1stMath from "./dc1stMathQuizContent";
import dc1stOther from "./dc1stOtherQuizContent";

// 2nd Grade
import dc2ndScience from "./dc2ndScienceQuizContent";
import dc2ndSocialStudies from "./dc2ndSocialStudiesQuizContent";
import dc2ndMath from "./dc2ndMathQuizContent";
import dc2ndOther from "./dc2ndOtherQuizContent";

// 3rd Grade
import dc3rdScience from "./dc3rdScienceQuizContent";
import dc3rdSocialStudies from "./dc3rdSocialStudiesQuizContent";
import dc3rdMath from "./dc3rdMathQuizContent";
import dc3rdOther from "./dc3rdOtherQuizContent";

// 4th Grade
import dc4thScience from "./dc4thScienceQuizContent";
import dc4thSocialStudies from "./dc4thSocialStudiesQuizContent";
import dc4thMath from "./dc4thMathQuizContent";
import dc4thOther from "./dc4thOtherQuizContent";

// 5th Grade
import dc5thScience from "./dc5thScienceQuizContent";
import dc5thSocialStudies from "./dc5thSocialStudiesQuizContent";
import dc5thMath from "./dc5thMathQuizContent";
import dc5thOther from "./dc5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const dctopicsMapBySubject = {
  // 1st Grade
  dc_1st_science: dc1stScience,
  dc_1st_socialstudies: dc1stSocialStudies,
  dc_1st_math: dc1stMath,
  dc_1st_other: dc1stOther,

  // 2nd Grade
  dc_2nd_science: dc2ndScience,
  dc_2nd_socialstudies: dc2ndSocialStudies,
  dc_2nd_math: dc2ndMath,
  dc_2nd_other: dc2ndOther,

  // 3rd Grade
  dc_3rd_science: dc3rdScience,
  dc_3rd_socialstudies: dc3rdSocialStudies,
  dc_3rd_math: dc3rdMath,
  dc_3rd_other: dc3rdOther,

  // 4th Grade
  dc_4th_science: dc4thScience,
  dc_4th_socialstudies: dc4thSocialStudies,
  dc_4th_math: dc4thMath,
  dc_4th_other: dc4thOther,

  // 5th Grade
  dc_5th_science: dc5thScience,
  dc_5th_socialstudies: dc5thSocialStudies,
  dc_5th_math: dc5thMath,
  dc_5th_other: dc5thOther,
  // ...add the rest
};
